import React from "react"
import { LayoutTestimonials } from "trimble-terra"
import { formatCommonComponentFields } from "./formatLayoutFunctions"

const FormatAndRenderLayoutTestimonials = ({
  data,
  locale,
  siteIdentifier,
  homepageSlug,
  currentSpaceId,
}) => {
  const formattedComponentData = formatCommonComponentFields(
    data,
    locale,
    siteIdentifier,
    homepageSlug,
    currentSpaceId
  )

  const isCarousel = data?.displayOptions?.includes("Carousel")

  const formattedQuoteCard = data?.testimonials?.map(testimonial => {
    return {
      ...testimonial,
      quote: testimonial?.longQuote?.longQuote,
      attributionName: testimonial?.author,
      attributionQualification: testimonial?.qualification,
    }
  })

  const formattedTestimonialsData = {
    ...formattedComponentData,
    testimonials: formattedQuoteCard,
    isCarousel: isCarousel,
  }

  return <LayoutTestimonials {...formattedTestimonialsData} />
}

export default FormatAndRenderLayoutTestimonials
